<template>
  <div class="materialDirection">
    <a-skeleton :loading="loading" active :paragraph="{ rows: 8 }">
      <div class="container">
        <a-tabs @change="tabChange" v-model="activeKey">
          <a-tab-pane class="tab-content" tab="素材风向标" key="1">
            <div class="vane">
              <a-row :gutter="24">
                <a-col :span="18">
                  <div class="rank-box">
                    <div class="rank-list" v-for="(rankList, i) in vaneInfo.rank_list" :key="rankList.id">
                      <div class="rank-list-title">
                        <div class="crown-Icon"></div>
                        <div class="titleStyle">
                          <div class="title">{{ rankList.rank_name }}</div>
                        </div>
                      </div>
                      <div class="rank-swiper">
                        <!-- <div class="hot"><img class="img" src="../../../assets/img/img_hot.png"></div> -->
                        <div class="hot-Icon"><div class="img"></div></div>
                        <swiper
                          ref="preViewSwiper"
                          :options="rankOption"
                          v-if="rankList.rank_package_list && rankList.rank_package_list.length > 0"
                        >
                          <swiper-slide v-for="(item, index) in rankList.rank_package_list" :key="item.id">
                            <div class="rank-item" @click.stop="openMaterialDetail(index, i, rankList)">
                              <div class="cover" :class="{ packageClass: rankList.type === 2 }">
                                <!-- <span class="rank-icon" :class="[index>2?`rank-all`:`rank-${index+1}`]" >{{ index>2? index+1:`` }}</span> -->
                                <img
                                  v-if="rankList.type === 2 && item.watermark_image"
                                  class="bg"
                                  :src="`${constv.QINIU_IMAGE_WATERMARK_CND_URL}${item.watermark_image}${constv.QINIU_IMAGE_WATERMARK_CND_CODE}`"
                                  alt=""
                                />
                                <img
                                  v-if="item.watermark_image"
                                  :src="`${constv.QINIU_IMAGE_WATERMARK_CND_URL}${item.watermark_image}${constv.QINIU_IMAGE_WATERMARK_CND_CODE}`"
                                  alt=""
                                />
                                <img v-else :src="`${constv.QINIU_IMAGE_CND_URL}${item.image}`" alt="" srcset="" />
                                <div class="text" v-if="rankList.display.num || rankList.display.notes">
                                  <span v-if="rankList.display.num">{{ item.picture_num }}张 </span>
                                  <span v-if="rankList.display.notes">热度：{{ item.heat }}</span>
                                </div>
                              </div>
                              <div class="info">
                                <p class="textInfo">
                                  <span
                                    class="rank-icon"
                                    v-if="rankList.display.ranking"
                                    :class="[index > 2 ? `rank-all` : `rank-${index + 1}`]"
                                  >
                                    <i class="num">{{ index > 2 ? index + 1 : `` }}</i></span
                                    >
                                  <span class="name">{{ item.package_name }}</span>
                                </p>
                                <p class="desc">画师：{{ item.author }}</p>
                              </div>
                            </div>
                          </swiper-slide>
                          <div
                            class="swiper-button-prev"
                            slot="button-prev"
                            v-show="rankList.rank_package_list.length > 5"
                          ></div>
                          <div
                            class="swiper-button-next"
                            slot="button-next"
                            v-show="rankList.rank_package_list.length > 5"
                          ></div>
                          <div
                            class="swiper-pagination"
                            slot="pagination"
                            v-show="rankList.rank_package_list.length > 5"
                          ></div>
                        </swiper>
                        <div v-else class="empty-status">
                          <div>
                            <img src="../../../assets/img/img_blank_118_86@2x.png" alt="" />
                            <p>数据统计中</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </a-col>
                <a-col :span="6">
                  <div class="notice-board" ref="board">
                    <div class="title">公告栏</div>
                    <div
                      class="notice-list"
                      v-if="vaneInfo.notice_list && vaneInfo.notice_list.length > 0"
                      :style="{ height: boardHeight - 96 + 'px' }"
                    >
                      <div
                        class="notice-item"
                        v-for="item in vaneInfo.notice_list"
                        :key="item.id"
                        @click="openDetail(item)"
                      >
                        <div class="notice-title">
                          {{ item.title }}
                        </div>
                        <div class="notice-content" v-html="changeHtml(item.content)"></div>
                        <div class="date">
                          {{ transformDate(item.gmt_modified) }}
                        </div>
                      </div>
                    </div>
                    <div v-else class="empty-notice">
                      <div>
                        <img src="../../../assets/img/img_blank_118_86@2x.png" alt="" />
                        <p>还没有公告发出哦～</p>
                      </div>
                    </div>
                  </div>
                </a-col>
              </a-row>
            </div>
          </a-tab-pane>
          <a-tab-pane class="tab-content" key="2">
            <div slot="tab" v-show="showDetail">
              <div class="tab-title">
                <span>{{ activeDetail.title || '公告' }}</span>
                <span class="close-tab-icon" @click.stop="closeDetail"> </span>
              </div>
            </div>
            <div class="notice-detail">
              <div class="notice-detail-title">
                {{ activeDetail.title }}
              </div>
              <div class="notice-detail-content" v-html="activeDetail.content"></div>
            </div>
          </a-tab-pane>
        </a-tabs>
      </div>
    </a-skeleton>
    <a-modal
      v-model="imgVisible"
      :destroy-on-close="true"
      :footer="null"
      :width="activeRankList.type == '2' ? '880px' : '760px'"
      centered
      :bodyStyle="{ padding: 0, overflow: 'hidden', borderRadius: '4px' }"
    >
      <span class="close-modal-icon" slot="closeIcon"></span>
      <div class="vaneDetail" :class="{ packageType: activeRankList.type == 2 }">
        <div class="vaneDetail-info" :class="{ dash: activeRankList.type == '2' }">
          <div class="cover">
            <img
              @click="
                showCover(
                  `${constv.QINIU_IMAGE_WATERMARK_CND_URL}${activeVane.watermark_image}${constv.QINIU_IMAGE_WATERMARK_CND_CODE}`
                )
              "
              v-if="activeVane.watermark_image"
              :src="`${constv.QINIU_IMAGE_WATERMARK_CND_URL}${activeVane.watermark_image}${constv.QINIU_IMAGE_WATERMARK_CND_CODE}`"
              alt=""
            />
            <img
              @click="showCover(`${constv.QINIU_IMAGE_CND_URL}${activeVane.image}`)"
              v-else
              :src="`${constv.QINIU_IMAGE_CND_URL}${activeVane.image}`"
              alt=""
            />
          </div>
          <div class="info">
            <div class="title">
              <span> {{ activeVane.package_name }}</span>
            </div>
            <div class="desc hide-text-1">画师：{{ activeVane.author }}</div>
            <div class="desc" v-if="activeRankList.display && activeRankList.display.notes">
              热度：{{ activeVane.heat }}
            </div>
            <div class="desc rank" v-if="activeRankList.display && activeRankList.display.ranking">
              排名：<span
                v-if="activeRankList.display && activeRankList.display.ranking"
                class="rank-icon"
                :class="[activeIndex > 2 ? `rank-all` : `rank-${activeIndex + 1}`]"
              ><i class="num">{{ activeIndex > 2 ? activeIndex + 1 : `` }}</i>
              </span>
            </div>
            <div
              class="desc tips"
              style="line-height: 21px"
              :class="[activeRankList.type == 2 ? 'hide-text-3' : 'hide-text-4']"
            >
              <span>{{ activeVane.notes }}</span>
            </div>
          </div>
        </div>
        <!-- <img class="line" src="../../../assets/img/img_dotted_ line_812@2x.png" alt=""> -->
        <div class="package-list-wrapper">
          <div class="package-list" v-if="activeRankList.type == '2'">
            <package-list
              :activeItem="activeVane"
              :showTitle="false"
              :option="{ itemWidth: 142, itemHeight: 142 }"
            ></package-list>
          </div>
        </div>
      </div>
    </a-modal>

    <preViewModal ref="preViewModal" :activeImg="activeCoverImg"></preViewModal>
  </div>
</template>

<script>
import packageList from '@/components/Zpace/packageList/packageList'
import preViewModal from '@/components/Zpace/modal/preViewModal'
import bgModal from '@/components/Zpace/modal/bgModal'
export default {
  name: 'MaterialDirection',
  data () {
    return {
      loading: true,
      vaneInfo: {},
      imgVisible: false,
      activeIndex: -1,
      activeSwiper: 0,
      activeVane: {},
      activeCoverImg: '',
      activeRankList: {},
      showDetail: false,
      activeDetail: {},
      activeKey: '1',
      boardHeight: '',
      rankOption: {
        slidesPerView: 'auto',
        spaceBetween: 32,
        slidesPerGroup: 5,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: false
        }
      }
    }
  },
  components: {
    packageList,
    preViewModal,
    bgModal
  },
  filters: {},
  computed: {
    userInfo () {
      return this.$store.state.user.info
    }
  },
  created () {
    this.loadData()
  },

  mounted () {},
  methods: {
    tabChange () {},
    showCover (url) {
      this.activeCoverImg = url
      this.$refs.preViewModal.showModal()
    },
    transformDate (val) {
      const date = val * 1000
      const year = new Date(date).getFullYear()
      const now = new Date().getFullYear()
      if (year === now) {
        return this.$moment.unix(val).format('MM/DD')
      } else {
        return this.$moment.unix(val).format('YYYY/MM/DD')
      }
    },
    changeHtml (html) {
      if (html.indexOf('<img') > -1) {
        // 如果有图片 最多显示三行
        var data = ''
        html.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/, function (match, capture) {
          data = capture
        })
        html = html.replace(/<img[^>]*>/g, '')
        return this.getSimpleText(html, 3) + `<img style="width:100%; height:auto; display:block;" src="${data}" />`
      } else {
        // 纯文本 最多显示4行
        return this.getSimpleText(html, 4)
      }
    },
    getSimpleText (html, num) {
      // var re1 = new RegExp('<p>', 'g')// 匹配html标签的正则表达式，"g"是搜索匹配多个符合的内容
      // var re2 = new RegExp('</p>', 'g')

      // var msg = html.replace(re1, '')// 执行替换成空字符
      // var msg = html.replace(/<p><br><\/p>/g, '')
      // msg = msg.replace(/<br>/g, '')
      // msg = msg.replace(/<p>/g, '')
      // msg = msg.replace(/<\/p>/g, '<br>')
      return `<div class="noticeHtml
        " style="overflow: hidden;
  height:100px;
  margin-bottom:20px;
  -webkit-box-orient: vertical;">${html}</div>`
    },
    async openMaterialDetail (index, i, rankList) {
      console.log(i)
      this.activeIndex = index
      this.activeVane = this.vaneInfo.rank_list[i].rank_package_list[index]
      this.activeVane.type = rankList.type
      if (rankList.type === 2) {
        await this.$api.materialDirection.getPackageInfo({ id: this.activeVane.package_id }).then((res) => {
          this.activeVane.res_data = res.data.reastom
        })
      }
      this.activeRankList = rankList
      this.imgVisible = true
    },
    loadData () {
      this.$api.materialDirection.getVaneInfo().then((res) => {
        if (res.status === 'ok') {
          this.loading = false
          this.vaneInfo = res.data
          this.$nextTick(() => {
            this.boardHeight = this.vaneInfo.rank_list.length * 417 + (this.vaneInfo.rank_list.length - 1) * 24
          })
        }
      })
    },
    closeDetail () {
      this.activeKey = '1'
      this.showDetail = false
    },
    openDetail (item) {
      this.activeKey = '2'
      this.activeDetail = item
      this.showDetail = true
    }
  },
  watch: {}
}
</script>

<style lang="less" scoped>
@import '../../../assets/less/utils.less';

.agree-modal {
  .title {
    color: @primary-color;
    text-align: center;
    font-size: 24px;
  }

  .ant-modal-body {
    padding: 0 24px;
  }
  .agree-content {
    padding: 0 24px;
    overflow: auto;
    margin-bottom: 50px;
    font-size: 18px;
    p {
      text-align: center;
    }
  }
  .agree-btn {
    text-align: center;
  }
}
/deep/ .ant-tabs-tab-active {
  .tab-title {
    .close-tab-icon {
      background-position: -142px -121px;
    }
  }
}
.tab-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .close-tab-icon {
    margin-left: 10px;
    width: 10px;
    height: 10px;
    background-image: url('../../../assets/img/zpace_icon_set.png');
    background-position: -108px -121px;
    &:hover {
      background-position: -176px -121px;
    }
  }
}
.rank-all {
  color: #999999;
  font-size: 11px;
  font-weight: 700;
  display: flex;
  justify-content: center;
  align-items: center;
  .num {
    position: relative;
    top: 1px;
  }
}
.vaneDetail {
  padding: 24px 0;
  //  .line {
  //    display: block;
  //    width: 100%;
  //    height: auto;
  //    margin: 24px 24px 0 24px;
  //  }
  &.packageType {
    padding: 24px 0 0;
    .vaneDetail-info {
      padding-bottom: 24px;
    }
    .cover {
      width: 218px;
      height: 218px;
      cursor: pointer;
      img {
      }
    }
    .package-list-wrapper {
      background-color: #fafafa;
      padding: 24px 8px 0 24px;
      .package-list {
        height: 390px;
        overflow-x: hidden;
        overflow-y: auto;
        padding-right: 8px;
        scrollbar-width: thin;
      }
    }
  }
  .vaneDetail-info {
    display: flex;
    margin: 0 24px;
    &.dash {
      border-bottom: 1px dashed #e5e5e5;
    }
  }
  .cover {
    width: 366px;
    height: 488px;
    margin-right: 24px;
    border: 1px solid #f2f2f2;
    position: relative;
    border-radius: 4px;
    overflow: hidden;
    img {
      display: block;
      position: absolute;
      left: 50%;
      top: 50%;
      -webkit-transform: translate(-50%, -50%);
      -ms-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);
      max-width: 100%;
      max-height: 100%;
    }
  }
  .info {
    flex: 1;
    .title {
      font-size: 20px;
      color: #000000;
      margin-bottom: 24px;
      display: flex;
      align-items: center;
      line-height: 1;
      .rank-icon {
        margin-right: 10px;
      }
    }
    .desc {
      font-weight: 400;
      color: rgba(154, 154, 154, 1);
      font-size: 12px;
      // color: #999999;
      margin-bottom: 24px;

      line-height: 1;
      &.rank {
        display: flex;
        align-items: center;
        margin-bottom: 15px;
      }
      &.tips {
        margin-bottom: 0;
        span {
          display: block;
          width: 100%;
          text-align: left;
        }
      }
    }
  }
}
.materialDirection {
  background-color: #fff;
  line-height: 1;

  .notice-detail {
    padding: 32px;
    .notice-detail-title {
      color: #333333;
      font-size: 20px;
      margin-bottom: 32px;
    }
    .notice-detail-content {
      font-size: 16px;
      color: #666666;

      /deep/ img {
        display: block;
        margin-top: 32px;
        margin-bottom: 32px;
        max-width: 800px !important;
      }
    }
  }
  /deep/ .ant-tabs-nav .ant-tabs-tab {
    padding: 16px 0;
  }
  /deep/ .ant-tabs-nav-container {
    margin-left: 20px;
  }

  .vane {
    line-height: 1;
    padding: 16px 32px 32px;
    .rank-box {
      margin-right: 40px;
      flex: 1;
      .rank-list {
        width: 100%;
        border: 1px solid #f2f2f2;
        border-radius: 16px;
        padding: 19px 0 0;
        box-sizing: border-box;
        &:not(:last-child) {
          margin-bottom: 24px;
        }
        .rank-list-title {
          // position: relative;
          // height: 38px;
          // top: 50%;
          display: flex;
          align-items: center;
          margin-bottom: 17px;
          margin-left: 20px;
        }
        .titleStyle {
          margin-left: 17px;
          // position: absolute;
          // margin-left: 17px;
          // transform: translate(10px, 10px);
          height: 24px;
          background: linear-gradient(-90deg, rgba(255, 183, 89, 1), rgba(255, 118, 99, 1));
          border-radius: 12px;
          // margin-bottom: 8px;
          .title {
            display: flex;
            align-items: center;
            font-size: 16px;
            color: rgba(255, 255, 255, 1);
            // margin-bottom: 24px;
            margin: 4px 12px 4px 0;
            padding-left: 24px;
            .rank-title-icon {
              // margin-right: 8px;
              margin: 2px;
            }
          }
        }
        .rank-swiper {
          box-sizing: border-box;
          position: relative;
          // .hot{
          //   .img{
          //     width: 50px;
          //     height: 50px;
          //   }
          //   position: absolute;
          //   right: 0;
          //   bottom: 0;
          // }
          .swiper-button-next.swiper-button-disabled {
            opacity: 1;
            background-position: -74px -537px;
          }
          .swiper-button-prev.swiper-button-disabled {
            opacity: 1;
            background-position: -24px -537px;
          }

          .empty-status {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 343px;
            text-align: center;
            p {
              margin-top: 24px;
              font-size: 14px;
              color: #999999;
            }
            img {
              display: block;
            }
          }
          &:hover {
            .swiper-button-prev {
              display: block;
            }
            .swiper-button-next {
              display: block;
            }
          }
          .swiper-pagination {
            bottom: 10px;
          }
          .swiper-button-prev {
            width: 40px;
            height: 78px;
            display: none;
            background-image: url('../../../assets/img/zpace_icon_set.png');
            background-position: -154px -537px;
            background-size: initial;
            left: 0;
            top: 35%;
            &:hover {
              background-position: -284px -537px;
            }
          }
          .swiper-button-next {
            width: 40px;
            height: 78px;
            display: none;
            background-image: url('../../../assets/img/zpace_icon_set.png');
            background-position: -204px -537px;
            background-size: 100%;
            background-size: initial;
            right: 0;
            top: 35%;
            &:hover {
              background-position: -334px -537px;
            }
          }

          .swiper-container {
            width: 100%;
            height: 100%;
            box-sizing: border-box;
            padding-bottom: 32px;
            padding-left: 32px;
            padding-right: 32px;
          }
          /deep/ .swiper-pagination-bullet-active {
            background-color: @primary-color;
          }
          /deep/ .swiper-pagination-clickable .swiper-pagination-bullet {
            margin-right: 12px;
          }
          .swiper-slide {
            width: 184px;
          }
          .rank-item {
            &:hover {
              cursor: pointer;
            }
            .cover {
              width: 184px;
              height: 245px;
              border-radius: 4px;
              border: 1px solid #f2f2f2;
              margin-bottom: 15px;
              position: relative;
              overflow: hidden;
              &.packageClass {
                display: flex;
                align-items: center;
                background-size: 100% 100%;
                background-repeat: no-repeat;
                position: relative;
                img {
                  z-index: 10;
                }
                &::after {
                  content: '';
                  display: block;
                  width: 100%;
                  height: 100%;
                  position: absolute;
                  z-index: 0;
                  background-color: rgba(0, 0, 0, 0.06);
                }
                .bg {
                  display: block;
                  content: '';
                  width: 100%;
                  height: 100%;
                  position: absolute;
                  top: 0;
                  left: 0;
                  filter: blur(12px);
                  z-index: -1;
                }
              }
              &:hover {
                border: 1px solid @primary-color;
              }
              // .rank-icon{
              //   position: absolute;
              //   top: 0;
              //   right: 8px;
              //   color: #999999;
              //   font-size: 14px;
              //   font-weight: 700;
              //   display: flex;
              //   justify-content: center;
              //   align-items: center;
              //   // width:24px;
              //   // height:24px;
              //   // background:rgba(71,199,189,0);
              // }
              img {
                width: 100%;
                height: auto;
                display: block;
              }
              .text {
                height: 32px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                position: absolute;
                width: 100%;
                padding: 0 10px;
                box-sizing: border-box;
                left: 0;
                bottom: 0;
                background-color: rgba(0, 0, 0, 0.5);
                color: #fff;
              }
            }
            .info {
              .textInfo {
                margin-top: 13px;
                display: flex;
              }
              .name {
                color: rgba(51, 51, 51, 1);
                font-size: 14px;
                line-height: 24px;
                flex: 1;
                .hideText(1);
                // width:70px;
                // height:13px;
                // font-size:14px;
                // font-family:Source Han Sans CN;
                font-weight: 400;
                // color:rgba(51,51,51,1);
                margin-left: 6px;
              }
              .desc {
                margin-top: 14px;
                color: #999999;
                font-size: 12px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 1;
                -webkit-box-orient: vertical;
                margin-left: 3px;
              }
            }
          }
        }
      }
    }

    .notice-board {
      border: 1px solid #f2f2f2;
      border-radius: 16px;
      box-sizing: border-box;
      padding: 24px 12px 24px 24px;
      .title {
        color: #333333;
        font-size: 16px;
        margin-bottom: 24px;
        position: relative;
        padding-left: 12px;

        &::after {
          content: '';
          display: block;
          width: 4px;
          height: 16px;
          border-radius: 2px;
          background-color: #ff7401;
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
        }
      }
      .notice-list {
        overflow: auto;
        padding-right: 12px;
        .notice-item {
          background-color: #fafafa;
          border-radius: 8px;
          padding: 20px;
          font-size: 14px;
          color: #666666;
          margin-bottom: 40px;
          position: relative;
          box-sizing: border-box;
          border: 1px solid #fafafa;
          &:hover {
            border: 1px solid @primary-color;
            cursor: pointer;
          }
          .notice-title {
            font-size: 16px;
            color: #333333;
            font-weight: 700;
            margin-bottom: 20px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          &:not(:last-child)::after {
            display: block;
            content: '';
            width: 100%;
            height: 0;
            border-top: 1px dashed #f2f2f2;
            position: absolute;
            bottom: -20px;
            left: 0;
          }
          .notice-content {
            margin-bottom: 20px;
            word-break: break-word;
            line-height: 24px;
            p {
              margin-bottom: 20px;
              img {
                width: 100%;
                height: auto;
                display: block;
              }
            }
            img {
              width: 100%;
              height: auto;
              display: block;
            }
          }
          .date {
            font-size: 12px;
            color: #999999;
            text-align: right;
          }
        }
      }
      .empty-notice {
        height: 700px;
        display: flex;
        justify-content: center;
        align-items: center;
        p {
          margin-top: 24px;
          font-size: 14px;
          color: #999999;
        }
        img {
          display: block;
        }
      }
    }
  }
}
</style>
